import { getRTL } from '@fluentui/react/lib/Utilities';
import * as trace from 'owa-trace';
import { onScaleElement, onUndoScaleElement } from './scaleControlManager';
import {
    doneHandlingWideContent,
    TABLE_TAG,
    undoHandleWideContent,
    WideContentHandler,
} from './wideContentHandler';
import { WIDE_CONTENT_HOST_CLASS_NAME } from './WideContentHost';

const styles = require('./ScaleElementStyles.scss');

export default function createWideContentHandler(): WideContentHandler {
    return {
        cssSelector: TABLE_TAG,
        keywords: null,
        undoHandler: undoHandleWideContent,
        doneHandlingMatchedElements: doneHandlingWideContent,
        handlingContentTimer: null,
        isRTL: getRTL(),
        wideContentHostClassName: WIDE_CONTENT_HOST_CLASS_NAME,
        scaleElementContainerClassName: styles.container,
        onScaleElement: onScaleElement,
        onUndoScaleElement: onUndoScaleElement,
        traceError: traceOwaError,
    };
}

function traceOwaError(message: string) {
    trace.errorThatWillCauseAlert(message);
}
